import LoginHeader from "@/shared/components/LoginHeader";
import {PaymentAPI} from "@/apis/PaymentAPI";

export default {
    name: "PaymentFailed.vue",
    components: {LoginHeader},
    async mounted() {
        await this.$store.dispatch('account/updateSubscriptionDetails');

    },
    methods: {
        downgrade() {
            this.$buefy.dialog.confirm({
                title: 'Downgrade to free Plan',
                message: 'Are you sure you want to <b>downgrade</b> your subscription?',
                confirmText: 'Yes',
                type: 'is-danger',
                hasIcon: false,
                onConfirm: async () => {
                    this.$emit('close');
                    await PaymentAPI.downgradeToFree();
                    await this.$router.push({name: 'account',});
                    // this.$emit('close');

                    //
                    // if (resp.success !== true) {
                    //     this.$buefy.dialog.alert('Opps..! Something wrong happened please try again later.')
                    // }
                    // await this.$store.commit('account/loaded');
                }
            })
        }
    },
    computed: {
        subscriptionDetails() {
            return this.$store.state.account.subscriptionDetails;
        }
    }
}
